import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/audits/(pages)/(list)')({
  component: lazyRouteComponent(
    () => import('../../-components/AuditsListLayout'),
    'AuditsListLayout',
  ),
});
